// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","wrapper--notice":"App_wrapper--notice__lTYFT","wrapper--app":"App_wrapper--app__kYlQN"};